(function () {
	'use strict';

	angular.module('qbePortal').directive('qbFormField', ['hierarchyDecorator', 'validationService', 'userInputRepository',
		function (hierarchyDecorator, validationService, userInputRepository) {
			return {
				restrict: 'A',
				controllerAs: 'vm',
				require: 'ngModel',
				scope: {
					name: '@',
					labelKey: '@',
					setHierarchy: '&?',
					commonValue: '@?',
					spinner:'<',
				},
				link: function (scope, element, attrs, ngModelCtrl, transclude) {
					var hasError = false;
					scope._element = element;
					var model = ngModelCtrl;

					scope.$on('broadcast-field-errors', function () {
						hasError = true;
					});

					function formIsSubmitted() {
						return hasError == true;
					}

					scope.$watch(function () {
						validationService.validateInput(element, ngModelCtrl, scope.labelKey);
						var parent = element.parents('div.ctrl-holder');
						if (!parent || !parent[0]) return;
						parent = $(parent).first();
						
						if (ngModelCtrl.$invalid && (ngModelCtrl.$dirty || formIsSubmitted())) {
							parent.addClass('is-error');
						} else {
							parent.find('[data-name='+scope.labelKey+']').addClass('ng-hide'); //applicable only for CTP forms
							parent.removeClass('is-error');
						}
					});

					if (scope.commonValue !== undefined) {
						// console.log( model.$modelValue ) ;
						model.$viewChangeListeners.push(function () {
							scope.$emit('common-value-update', {name: scope.commonValue, value: model.$modelValue});
						});
						model.$formatters.push(function () {
							/** run on initialisation of model value */
							scope.$emit('common-value-update', {name: scope.commonValue, value: model.$modelValue});
							return model.$modelValue;
						});
					}

					if (scope.setHierarchy !== undefined)
						hierarchyDecorator.attach(scope, {element: scope._element, name: scope.name});
				}
			};
		}]);
})();
